import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/HTML DOM/ResizeObserverEntry";
import * as React from 'react';
export default {
  Content,
  React
};